import {
  getDispatchLoader
} from '@modules/dispatchForm'

const attr = {
  button: '[data-loading]'
}

const mount = () => {
  document.addEventListener('click', onClickSocialButton)
}

const onClickSocialButton = ({ target }) => {
  const bubblingTarget = target.closest(attr.button)
  if (!bubblingTarget) return

  getDispatchLoader({
    status: 'pending',
    context: bubblingTarget.parentNode,
    target: bubblingTarget
  })

  /**
   * remove loading after 4s
   */
  setTimeout(() => {
    getDispatchLoader({
      status: 'completed',
      context: bubblingTarget.parentNode,
      target: bubblingTarget
    })
  }, 4000)
}

export default { mount }
